import React from "react";
import { Label, TextArea, TextField } from "react-aria-components";
import { useFormContext } from "react-hook-form";

type TextAreaProps = {
  label?: string;
  description?: string;
  errorMessage?: string;

  onChange?: (e: string | number | any) => void;
  name?: string;
  placeHolder?: string;
  rows?: number;
  disabled?: boolean;
};

export default function TextAreaUi({
  label,
  description,

  onChange,
  name,
  placeHolder,
  rows,
  disabled,
  ...props
}: TextAreaProps) {
  const {
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const filedName = name || "";
  const errorMessage = errors[filedName] || {
    message: "",
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const error = errorMessage?.message?.toString() || "";

  const value = getValues(filedName);
  return (
    <TextField
      isDisabled={disabled}
      value={value}
      onChange={(e) => {
        clearErrors(filedName);
        setValue(filedName, e);
      }}
      className={``}
      {...props}
    >
      <Label htmlFor={name} className="text-sm font-medium ">
        {label}
      </Label>

      <TextArea
        defaultValue={value}
        value={value}
        rows={rows}
        placeholder={placeHolder}
        className={`p-3 block w-full focus:outline-none rounded-md text-sm  bg-[#FBFBFB] h-24 border border-[#f0f0f0]  text-gray-900  placeholder:text-gray-400  ${
          disabled ? " cursor-not-allowed bg-bg_dark_gray opacity-30" : ""
        }`}
      />
    </TextField>
  );
}
